export class XYZModel {
    x: number;
    y: number;
    z: number;

    static toArray(v: XYZModel): [number, number, number] {
        return [v.x, v.y, v.z];
    }

    static fromArray(v: [number, number, number]): XYZModel {
        return {
            x: v[0],
            y: v[1],
            z: v[2]
        };
    }
}
